import 'bootstrap/dist/js/bootstrap.js';
import 'angular';
import 'angular-animate';
import 'angular-aria';
import 'angular-bind-html-compile';
import 'angular-cookies';
import 'angular-credit-cards';
import 'angular-dynamic-locale';
import 'angular-local-storage';
import 'angular-messages';
import 'angular-recaptcha';
import 'angular-route';
import 'angular-sanitize';
import 'angular-scroll';
import 'slick-carousel';
import 'angular-slick-carousel'; //depends on slick-carousel
import 'angular-translate';
import 'angular-translate-loader-partial';
import 'angular-translate-loader-static-files';
import 'angular-ui-bootstrap';
import 'angular-utf8-base64';
import 'angularjs-slider';
import 'bootstrap-tabdrop/build/js/bootstrap-tabdrop.min.js';
import humanizeDuration from 'humanize-duration';
window.humanizeDuration = humanizeDuration;
import 'jquery-placeholder';
import 'jquery.cookie';
import 'jquery.ioslist/dist/js/jquery.ioslist';
import 'dayjs';
import 'ng-combo-date-picker';
import 'ng-device-detector';
import 'ng-infinite-scroll/build/ng-infinite-scroll';
import 'malihu-custom-scrollbar-plugin';
import 'ng-scrollbars'; //depends on malihu-scrollbar-plugin
import 'rx-angular';
import 'selectize/dist/js/standalone/selectize';
import 'sticky-kit/dist/sticky-kit';
import 'ui-select';
import 'oclazyload';


/** LIBRARIES */
import '../decorators';
import 'ib-web-commons';
import 'ib-menus';
// import 'ib-web-payments';
// import 'ib-web-ancillaries';


/** APP */
import '../ib-checkin-templates';
import '../app';
import '../components/routing';
import '../components/filters';
import '../components/services';
import '../components/ib-reusable-components';
import '../components/ib-check-in-apis';
// import '../components/ib-check-in-boarding-cards';
import '../components/ib-check-in-flight-now';
// import '../components/ib-check-in-flights-des-invoice';
import '../components/ib-check-in-flights-passengers';
// import '../components/ib-check-in-fly-now-confirmation-pa';
import '../components/ib-check-in-ib-plus';
import '../components/ib-check-in-search';
// import '../components/ib-check-in-upgrade';
// import '../components/ib-checkin-biometric-boarding';
